import React, { useMemo } from 'react'
import HealthTeamContext from '../context/HealthTeamContext'
import { useAuth0 } from '@auth0/auth0-react'

const HealthTeamProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()

  const serviceId = useMemo(() => {
    try {
      const querystring = window.location.search
      const params = new URLSearchParams(querystring)
      const serviceIdFromQuery = params.get('serviceId')

      return serviceIdFromQuery ? parseInt(serviceIdFromQuery, 10) : null
    } catch {
      return null
    }
  }, [])

  const getHealthTeam = async () => {
    const idToken = await getIdTokenClaims()
    const response = await fetch(
      `${process.env.REACT_APP_PATIENTS_API_BASE_URL}/v1/patients/doctors-history?plenna_service_id=${serviceId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken.__raw}`
        }
      }
    )
    const data = await response.json()
    return data.data
  }

  return (
    <HealthTeamContext.Provider value={{ getHealthTeam }}>
      {children}
    </HealthTeamContext.Provider>
  )
}

export default HealthTeamProvider
